//# sourceMappingURL=data_sources.mjs.map
/// <reference types="./data_sources.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $user_id from "../../../data_types/data/auth/user_id.mjs";
import * as $data_source from "../../../data_types/data/data_source.mjs";
import { DataSource } from "../../../data_types/data/data_source.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $calendar from "../../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $super_admin from "../../admin/effects/super_admin.mjs";
import { apply_org_header } from "../../admin/effects/super_admin.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $data_sources from "../../data/data_sources.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList } from "../../gleam.mjs";

export function fetch_by_page(org_id, page) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      let $ = $data_sources.get(store.data_sources, org_id, page);
      if ($ instanceof Ok) {
        let $1 = $[0];
        if ($1 instanceof $remote.NotLoaded) {
          return $middleware.require_access_token(
            store.client,
            (access_token) => {
              dispatch(
                new $msg.DataSources(
                  new $msg.ApiStartedLoadingDataSources(org_id, page),
                ),
              );
              let _pipe = $ask.to(
                new $ask.Heimdall(),
                toList(["admin", "data-sources", org_id]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Get());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = apply_org_header(_pipe$2, store);
              let _pipe$4 = $ask.query(_pipe$3, "page", $int.to_string(page));
              let _pipe$5 = $ask.expect(
                _pipe$4,
                $decode.field(
                  "total",
                  $decode.int,
                  (total) => {
                    return $decode.field(
                      "data-sources",
                      $decode.list(
                        $decode.field(
                          "document_id",
                          $decode.string,
                          (document_id) => {
                            return $decode.field(
                              "data_sources",
                              $decode.list($data_source.decoder()),
                              (data_sources) => {
                                return $decode.success(
                                  [document_id, data_sources],
                                );
                              },
                            );
                          },
                        ),
                      ),
                      (data_sources) => {
                        return $decode.success([total, data_sources]);
                      },
                    );
                  },
                ),
              );
              let _pipe$6 = $ask.on_success(
                _pipe$5,
                (data_sources) => {
                  let total = data_sources[0];
                  let data_sources$1 = data_sources[1];
                  let _pipe$6 = data_sources$1;
                  let _pipe$7 = ((_capture) => {
                    return new $msg.ApiReturnedDataSources(
                      org_id,
                      page,
                      total,
                      _capture,
                    );
                  })(_pipe$6);
                  let _pipe$8 = new $msg.DataSources(_pipe$7);
                  dispatch(_pipe$8);
                  return undefined;
                },
              );
              let _pipe$7 = $ask.on_error(
                _pipe$6,
                (error) => {
                  let _pipe$7 = error;
                  let _pipe$8 = $string.inspect(_pipe$7);
                  let _pipe$9 = ((_capture) => {
                    return new $msg.ApiErroredDataSources(
                      org_id,
                      page,
                      _capture,
                    );
                  })(_pipe$8);
                  let _pipe$10 = new $msg.DataSources(_pipe$9);
                  dispatch(_pipe$10);
                  return undefined;
                },
              );
              return $ask.run(_pipe$7);
            },
          );
        } else if ($1 instanceof $remote.Loading) {
          return $promise.resolve(undefined);
        } else if ($1 instanceof $remote.Errored) {
          return $promise.resolve(undefined);
        } else {
          return $promise.resolve(undefined);
        }
      } else {
        return $middleware.require_access_token(
          store.client,
          (access_token) => {
            dispatch(
              new $msg.DataSources(
                new $msg.ApiStartedLoadingDataSources(org_id, page),
              ),
            );
            let _pipe = $ask.to(
              new $ask.Heimdall(),
              toList(["admin", "data-sources", org_id]),
            );
            let _pipe$1 = $ask.via(_pipe, new $http.Get());
            let _pipe$2 = $ask.bearing(_pipe$1, access_token);
            let _pipe$3 = apply_org_header(_pipe$2, store);
            let _pipe$4 = $ask.query(_pipe$3, "page", $int.to_string(page));
            let _pipe$5 = $ask.expect(
              _pipe$4,
              $decode.field(
                "total",
                $decode.int,
                (total) => {
                  return $decode.field(
                    "data-sources",
                    $decode.list(
                      $decode.field(
                        "document_id",
                        $decode.string,
                        (document_id) => {
                          return $decode.field(
                            "data_sources",
                            $decode.list($data_source.decoder()),
                            (data_sources) => {
                              return $decode.success(
                                [document_id, data_sources],
                              );
                            },
                          );
                        },
                      ),
                    ),
                    (data_sources) => {
                      return $decode.success([total, data_sources]);
                    },
                  );
                },
              ),
            );
            let _pipe$6 = $ask.on_success(
              _pipe$5,
              (data_sources) => {
                let total = data_sources[0];
                let data_sources$1 = data_sources[1];
                let _pipe$6 = data_sources$1;
                let _pipe$7 = ((_capture) => {
                  return new $msg.ApiReturnedDataSources(
                    org_id,
                    page,
                    total,
                    _capture,
                  );
                })(_pipe$6);
                let _pipe$8 = new $msg.DataSources(_pipe$7);
                dispatch(_pipe$8);
                return undefined;
              },
            );
            let _pipe$7 = $ask.on_error(
              _pipe$6,
              (error) => {
                let _pipe$7 = error;
                let _pipe$8 = $string.inspect(_pipe$7);
                let _pipe$9 = ((_capture) => {
                  return new $msg.ApiErroredDataSources(org_id, page, _capture);
                })(_pipe$8);
                let _pipe$10 = new $msg.DataSources(_pipe$9);
                dispatch(_pipe$10);
                return undefined;
              },
            );
            return $ask.run(_pipe$7);
          },
        );
      }
    },
  );
}

export function update_expiration_date(data_source_id, date, page) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Heimdall(), toList(["content-library"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Patch());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.with$(
            _pipe$3,
            $json.object(
              toList([
                [
                  "data_source_ids",
                  $json.array(toList([data_source_id]), $json.string),
                ],
                [
                  "expiration_date",
                  $json.string(
                    $timestamp.to_rfc3339(date, $calendar.utc_offset),
                  ),
                ],
              ]),
            ),
          );
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $decode.list($data_source.decoder()),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (sources) => {
              return $list.each(
                sources,
                (source) => {
                  let _pipe$6 = new $msg.ApiReturnedDataSource(page, source);
                  let _pipe$7 = new $msg.DataSources(_pipe$6);
                  return dispatch(_pipe$7);
                },
              );
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function update_owner(data_source_id, owner, page) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Heimdall(), toList(["content-library"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Patch());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.with$(
            _pipe$3,
            $json.object(
              toList([
                [
                  "data_source_ids",
                  $json.array(toList([data_source_id]), $json.string),
                ],
                ["owner_id", $user_id.encode(owner)],
              ]),
            ),
          );
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $decode.list($data_source.decoder()),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (sources) => {
              return $list.each(
                sources,
                (source) => {
                  let _pipe$6 = new $msg.ApiReturnedDataSource(page, source);
                  let _pipe$7 = new $msg.DataSources(_pipe$6);
                  return dispatch(_pipe$7);
                },
              );
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function update_authors(data_source_id, authors, page) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Heimdall(), toList(["content-library"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Patch());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.with$(
            _pipe$3,
            $json.object(
              toList([
                [
                  "data_source_ids",
                  $json.array(toList([data_source_id]), $json.string),
                ],
                ["authors", $json.array(authors, $user_id.encode)],
              ]),
            ),
          );
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $decode.list($data_source.decoder()),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (sources) => {
              return $list.each(
                sources,
                (source) => {
                  let _pipe$6 = new $msg.ApiReturnedDataSource(page, source);
                  let _pipe$7 = new $msg.DataSources(_pipe$6);
                  return dispatch(_pipe$7);
                },
              );
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function delete_tag(source, tag_id, page) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["content-library", "tags"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.with$(
            _pipe$3,
            $json.array(
              toList([[tag_id, source.id]]),
              (_use0) => {
                let tag_id$1 = _use0[0];
                let source_id = _use0[1];
                return $json.object(
                  toList([
                    ["tag_id", $json.string(tag_id$1)],
                    ["source_id", $json.string(source_id)],
                  ]),
                );
              },
            ),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (_) => {
              let source$1 = new DataSource(
                source.id,
                source.status,
                source.display,
                source.kind,
                source.authors,
                source.owner,
                source.document_id,
                source.blob_link,
                source.content_link,
                source.hash,
                source.version,
                $list.filter(source.tags, (tag) => { return tag !== tag_id; }),
                source.org_id,
                source.expiration_date,
              );
              let _pipe$5 = new $msg.ApiReturnedDataSource(page, source$1);
              let _pipe$6 = new $msg.DataSources(_pipe$5);
              dispatch(_pipe$6);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function add_tag(source, tag_id, page) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["content-library", "tags"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.with$(
            _pipe$3,
            $json.array(
              toList([[tag_id, source.id]]),
              (_use0) => {
                let tag_id$1 = _use0[0];
                let source_id = _use0[1];
                return $json.object(
                  toList([
                    ["tag_id", $json.string(tag_id$1)],
                    ["source_id", $json.string(source_id)],
                  ]),
                );
              },
            ),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (_) => {
              let source$1 = new DataSource(
                source.id,
                source.status,
                source.display,
                source.kind,
                source.authors,
                source.owner,
                source.document_id,
                source.blob_link,
                source.content_link,
                source.hash,
                source.version,
                $list.append(source.tags, toList([tag_id])),
                source.org_id,
                source.expiration_date,
              );
              let _pipe$5 = new $msg.ApiReturnedDataSource(page, source$1);
              let _pipe$6 = new $msg.DataSources(_pipe$5);
              dispatch(_pipe$6);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}
